import { useState } from 'react';
import { useVisibleWithSelected } from './useVisibleWithSelected';

const INITIAL_SLICE_SIZE_MOBILE = 4;
const INITIAL_SLICE_SIZE_DESKTOP = 5;

export const useOptionsPagination = ({
  list,
  screenSize,
  selectedIndex,
  getKey,
}) => {
  const [sliceSize, setSliceSize] = useState(
    screenSize.width < 600
      ? INITIAL_SLICE_SIZE_MOBILE
      : INITIAL_SLICE_SIZE_DESKTOP
  );
  const [isAll, setIsAll] = useState(false);

  const visible = useVisibleWithSelected({
    base: list,
    sliceSize,
    isExpanded: isAll,
    selectedIndex,
    getKey,
  });

  const showAll = () => {
    setSliceSize(list.length);
    setIsAll(true);
  };

  return { visible, isAll, showAll, sliceSize };
};
